const ARTICLE_FIELDS = `
  items {
    ItemId
    Title
    Content
    coverImageUrl
    CreatedDate
    CreatedBy
    LastUpdatedDate
    LastUpdatedBy
    IsDeleted
    Language
    OrganizationId
    Tags
    DeletedDate
    isDraft
    categoryIds
    authorSnapshot {
      firstName
      lastName
      email
      profileImageUrl
    }
    attachmentUrls {
      id
      name
      size
      url
      mimeType
    }
  }
`;

// NOTE: no call sites — converted for consistency only.
export const GET_ALL_ARTICLES = `
  query GetAllArticles($where: wikiFilterInput) {
    getwikis(where: $where, paging: { pageNo: 1, pageSize: 1000 }) {
      totalCount
      ${ARTICLE_FIELDS}
    }
  }
`;

export const GET_ARTICLES = `
  query GetArticles(
    $where: wikiFilterInput
    $pageNo: Int!
    $pageSize: Int!
  ) {
    getwikis(where: $where, paging: { pageNo: $pageNo, pageSize: $pageSize }) {
      ${ARTICLE_FIELDS}
    }
  }
`;

// NOTE: no call sites — converted for consistency only.
export const GET_ARTICLE = `
  query GetArticle($where: wikiFilterInput) {
    getwikis(where: $where, paging: { pageNo: 1, pageSize: 1 }) {
      ${ARTICLE_FIELDS}
    }
  }
`;

export const DELETE_ARTICLE = `
  mutation DeleteArticle($itemId: String!) {
    deletewiki(
      where: { ItemId: { eq: $itemId } }
      input: { isHardDelete: true }
    ) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

export const CREATE_ARTICLE = `
  mutation CreateArticle($input: wikiInsertInput!) {
    insertwiki(input: $input) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

export const UPDATE_ARTICLE = `
  mutation UpdateArticle($itemId: String!, $input: wikiUpdateInput!) {
    updatewiki(where: { ItemId: { eq: $itemId } }, input: $input) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

// Bulk update: refresh the author snapshot on every article by this user after
// a profile edit (used by user-name-snapshot-sync).
export const UPDATE_MANY_WIKI_AUTHOR_SNAPSHOT = `
  mutation UpdateManyWikiAuthorSnapshot(
    $createdBy: String!
    $firstName: String
    $lastName: String
    $email: String
    $profileImageUrl: String
  ) {
    updateManywiki(
      where: { CreatedBy: { eq: $createdBy } }
      input: {
        authorSnapshot: {
          firstName: $firstName
          lastName: $lastName
          email: $email
          profileImageUrl: $profileImageUrl
        }
      }
    ) {
      acknowledged
      totalImpactedData
      message
    }
  }
`;
